import React from "react";

//Link
import { Link } from "react-router-dom";

export default function Paragraph(props) {
  const { data } = props;
  return data.type === "left" ? (
    <div className="left-para">
      <div className="details">
        <div className="text">
          <span className="overlay">{data.overlay}</span>
          <h2>{data.title}</h2>
        </div>
        <hr />
        <p>{data.para}</p>
        {data.path == null ? null : (
          <Link to={data.path} className="path">
            Check out!
          </Link>
        )}
      </div>
      <div className="Image">
        <img src={data.img} alt={data.title} title={data.title} />
      </div>
    </div>
  ) : data.type === "right" ? (
    <div className="right-para">
      <div className="Image">
        <img src={data.img} alt={data.title} title={data.title} />
      </div>
      <div className="details">
        <div className="text">
          <span className="overlay">{data.overlay}</span>
          <h2>{data.title}</h2>
        </div>
        <hr />
        <p>{data.para} </p>
        {data.path == null ? null : (
          <Link to={data.path} className="path">
            Check out!
          </Link>
        )}
      </div>
    </div>
  ) : data.type === "center" ? (
    <div className="center-para">
      <div className="details">
        <div className="text">
          <span className="overlay">{data.overlay}</span>
          <h2>{data.title}</h2>
        </div>
        <div className="hr">
          <hr />
        </div>
        <p>{data.para} </p>
        {data.path == null ? null : (
          <Link to={data.path} className="path">
            Check out!
          </Link>
        )}
      </div>
    </div>
  ) : null;
}

export const MultiParagraph = (props) => {
  const { data } = props;
  return (
    <div className="multi-para">
      <div className="Image">
        <img src={data.img} alt={data.title} title={data.title} />
      </div>
      <div className="details">
        <div className="text">
          <span className="overlay">{data.overlay}</span>
          <h2>{data.title}</h2>
        </div>
        <div className="hr">
          <hr />
        </div>
        <p>{data.para}</p>
        {data.path == null ? null : (
          <Link to={data.path} className="path">
            Check out!
          </Link>
        )}
      </div>
    </div>
  );
};
